module.exports = __webpack_public_path__ + "img/icono_swpder.21231f52.svg";